import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
    selector: 'app-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss'],
    standalone: false
})
export class FilterComponent implements OnInit, OnChanges  {
  @Input() filterType: string = '';
  @Input() filters: any = [];
  @Input() selectedFilter: string = '';// for radio-button
  @Input() placeholder: string = '';
  @Input() size: string = '';
  @Input() searchId: string = '';
  @Input() searchDisplay: string = '';
  @Input() componentName: string = '';
  @Input() selectedOption: number | string = 2024;// for dropdown
  @Output() afterChange = new EventEmitter();
  @Output() onFilterChange = new EventEmitter<any>();
  @Input() className: string = 'form-select';
  @Input() dynamicClass: string = 'gap-20';
  @Input() dynamicLabelColor: string = '#4f4f4f';
  @Input() dynamicGap: string = 'gap-2';
  @Input() titleName: string = '';
  selectedOptionDropdown: number | string = 2024;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedOption']) {
    this.selectedOptionDropdown = this.selectedOption;
  }
  }

  ngOnInit(): void {}
  
  fnOnFilterChange(type: string, value?: string | number) {
    switch (type) {
      case 'radio-filter':
        this.onFilterChange.emit({ type, value });
        break;
      case 'custom-search-dropdown':
        this.afterChange.emit(value);
        break;
      case 'select-dropdown':
        this.onFilterChange.emit(value);
        break;
    }
  }
}
